import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteBranch from "../../../components/Staff/Modals/DeleteBranch";
import ClipLoader from "react-spinners/ClipLoader";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import Cookies from "js-cookie";
import { useAuthContext } from "../../../Context/AuthContext";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { HeaderSkeleton, PaginationSkeleton, TableSkeleton } from "../Skelton/Skelton";

const BranchDetails = () => {
  const { baseUrl, openToast, fetchBranch, branchData, loadingBranch, setBranchItem,setBranchData } = useGlobalContext();
  const [id, setId] = useState(null);
  const [rowsToShow, setRowsToShow] = useState(0);
  const [exportFormat, setExportFormat] = useState("CSV");
  const { flowChangerToken } = useAuthContext();
  const [searchBranchName, setSearchBranchName] = useState("");
  const [isSearching, setIsSearching] = useState(false);



  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchBranchName(value);

    if (value.trim() === "") {
      fetchBranch();
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(`${baseUrl}branch/search?branchName=${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setBranchData(data || []);
      } else {
        openToast(data.message, "error");
      }
    } catch (error) {
      console.error("Error searching roles:", error);
    } finally {
      setIsSearching(false);
    }
  };

  // Export Functionality
  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printBranch();
  };

  const exportCSV = () => {
    const headers = ["Branch Name"];
    const csvData = [
      headers.join(","),
      ...branchData.map((dep) => `${dep.branchName}`),
    ].join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "branchData.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Branch Details", 20, 10);
    branchData.forEach((dep, index) => {
      doc.text(`${index + 1}. ${dep.branchName}`, 10, 20 + index * 10);
    });
    doc.save("branchData.pdf");
  };

  const printBranch = () => {
    const printWindow = window.open("", "_blank");
    const printContent = `
      <html>
        <head><title>Print Branch Details</title></head>
        <body>
          <h3>Branch Details</h3>
          <table border="1" cellspacing="0" cellpadding="5">
            <thead>
              <tr>
                <th>Branch Name</th>
               </tr>
            </thead>
            <tbody>
              ${branchData.map(
      (row) =>
        `<tr><td>${row?.branchName}</td></tr>`
    ).join("")}
            </tbody>
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  async function deletebranchDatas(id) {
    try {
      const result = await fetch(baseUrl + `branch/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        }
      });
      if (result.status == 200) {
        openToast("Delete Branch Successfully", "success");
        setId(null);
        fetchBranch();
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    if (branchData?.length == 0) {
      fetchBranch();
    }
  }, []);

  if (loadingBranch && branchData.length === 0) {
    return (
      <div className="bg-white mt-[20px] px-4 py-6 w-full staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }



  return (
    <div className="bg-white px-4 py-6 w-full">
      <DeleteBranch id={id} setId={setId} deleteBranch={deletebranchDatas} />

      {/* Add New Branch Button */}
      <Link to="/add-branch" className="allcrm-btn">
        <AddIcon className="addicon-all" /> New Branch
      </Link>

      <div className="bg-white shadow-cs mt-5 p-[20px] rounded-lg table-section">
        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 mb-3">
          {/* Entries Dropdown & Export Options */}
          <div className="flex sm:flex-row flex-col flex-wrap items-center gap-2 w-full">
            <select
              onChange={handleSelectChange}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[60px] text-[14px] focus:outline-none"
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="120">120</option>
            </select>
            <select
              onChange={(e) => setExportFormat(e.target.value)}
              className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md w-full sm:w-[67px] text-[14px] focus:outline-none"
            >
              <option value="CSV">CSV</option>
              <option value="PDF">PDF</option>
              <option value="Print">Print</option>
            </select>
            <button
              onClick={handleExport}
              className="bg-[#27004a] p-[7px] rounded-md w-full sm:w-[83px] text-[14px] text-white cursor-pointer"
            >
              Export File
            </button>
          </div>

          {/* Search Bar */}
          <div className="relative flex flex-wrap justify-end items-center gap-2 w-full">
            <input
              type="text"
              placeholder="Search Branch..."
              value={searchBranchName}
              onChange={handleSearch}
              className="border-1 p-[10px] pr-7 border rounded-3xl w-[100%] md:w-[200px] h-[38px] text-[#000] text-[15px] focus:outline-none"
            />
            <SearchIcon className="right-[10px] absolute search-icon text-[#dddddd]" />
          </div>
        </div>

        {/* Table Section */}
        <div className="bg-white shadow-cs rounded-lg w-full overflow-x-auto">
          <table className="p-[10px] w-[100%] table-auto">
            <thead className="bg-[#ffff]">
              <tr>
                <th className="border-[#dbdbdb] p-4 border-b font-medium text-center text-sm">
                  Branch Name
                </th>
                <th className="border-[#dbdbdb] p-4 border-b font-medium text-center text-sm">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              { 
              !isSearching && branchData?.length > 0 ? (
                branchData.map((item, index) => (

                  <tr key={index} className="border-[#dbdbdb] pb-2 border-b">
                    <td className="border-[#dbdbdb] pt-4 pb-3 pl-3 border-r">{item?.branchName}</td>
                    <td className="flex justify-center gap-2 pt-4">
                      <Link to="/update-branch">
                        <BorderColorIcon className="text-[#27004a] cursor-pointer" onClick={()=>{
                          console.log(item)
                          setBranchItem(item)
                        }} />
                      </Link>
                      <DeleteIcon className="text-red-500 cursor-pointer" onClick={() => setId(item?.id)} />
                    </td>
                  </tr>

                  
                ))
              ) : (
                <tr><td colSpan="2" className="py-4 text-center">No Branch Found</td></tr>
              )}
            </tbody>
          </table>



        </div>
        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[16px] pr-0 pb-[0] pl-0 w-[100%]">
          <p className="text-[#a5a1a1] text-[14px]">
            Showing 1 to {rowsToShow} of {branchData?.length} entries
          </p>
          <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
            <Link to="#" className="pt-2 pb-[8px] text-[12px]">
              Previous
            </Link>
            <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
              1
            </span>
            <Link to="#" className="pt-2 pb-[8px] text-[12px]">
              Next
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchDetails;
